import React, { useState } from "react";
import {
  CustomButton,
  CustomModal,
  CustomModalWithoutButton,
  CustomParagraph,
  CustomTitle,
} from "../../../components";
import { Col, Flex, Form, Row } from "antd";

// Assest
import pharmaImg1 from "../../../assets/images/pharma-img1.png";
import pharmaImg2 from "../../../assets/images/pharma-img2.png";
import pharmaImg3 from "../../../assets/images/pharma-img3.png";
import WhitePaperDownload from "./WhitePaperDownload";
import { useSpin } from "../../../components/SpinContext";

const WhitePaper = () => {
  const [form] = Form.useForm();
  const { showSpin, hideSpin } = useSpin();

  const [modalOpen, setModalOpen] = useState(false);
  const openWhitePaperModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  }

  return (
    <>
      <div className="white-paper-wrapper">
        <div className="">
          <Row
            gutter={[0, 24]}
            align="middle"
            justify=""
            className="white-paper-row"
          >
            <Col xs={24} sm={24} lg={16} xl={14}>
              <div className="white-paper-images">
                <img src={pharmaImg1} alt="" />
                <img src={pharmaImg2} alt="" />
                <img src={pharmaImg3} alt="" />
              </div>
            </Col>
            <Col xs={24} sm={24} lg={16} xl={6} className="white-paper-right">
              <CustomTitle
                text="Read a new white paper examining the key challenges in Pharma Logistics"
                fontSize="20px"
                fontWeight="800"
                lineHeight="28px"
                color="black"
                marginBottom="8px"
              />
              <CustomParagraph
                text="Discover how improved visibility of your Pharma shipments can lead to better patient outcomes and reduced loss rates."
                fontSize="16px"
                fontWeight="400"
                lineHeight="28px"
                color="black"
                marginBottom="20px"
              />
              <CustomButton
                text="Download the white paper"
                block="block"
                height="48px"
                bgColor="#266EF1"
                color="#fff"
                borderRadius="8px"
                fontSize={16}
                fontWeight={500}
                htmlType="submit"
                width="235px"
                boxShadow="none"
                onClick={() => openWhitePaperModal()}
              />
            </Col>
          </Row>
        </div>
      </div>
      <CustomModalWithoutButton
        modalTitle="Download White Paper"
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalSize={400}
        buttonText2="Download"
      >
        <WhitePaperDownload closeModal={closeModal} />
      </CustomModalWithoutButton>
    </>
  );
};

export default WhitePaper;
